<template>
  <RadialChartWrapper
    v-if="showChart"
    :actionButtonHandler="navigateToMDMPage"
    :certificateDetails="certificateDetails"
    data-test-id="mdmRadialBarCharts"
    :displayName="displayName"
    :hasError="hasError"
    :isLoading="isLoading"
    :type="radialBar"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import { mapActions } from 'vuex';
import AppleVppApi from 'client/api/v2/AppleVppApi';
import DateUtil from 'client/util/DateUtil';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import MdmsApi from 'client/api/v2/MdmsApi';
import RadialChartWrapper from 'client/HomePageV2/charts/RadialChartWrapper.vue';
import SegmentEventMixin from 'client/HomePageV2/mixins/SegmentEventMixin';
import Util from 'client/util/Util';

const mdmRoutes = ItemTypeRoutes[ItemTypeConsts.mdmSettings];
const { widgetTypes, widgetNames } = HomeWidgetConsts;
const percentage = 100;
const administratorModel = 'AdministratorModel';

export default {
  name: 'MDMCertificateExpirationsWidget',
  components: {
    RadialChartWrapper,
  },

  mixins: [SegmentEventMixin],

  mdmRoutes,

  data: () => ({
    hasError: false,
    isLoading: true,
    radialBar: 'radialBar',
    certificateDetails: [],
  }),

  computed: {
    displayName() {
      return widgetNames[widgetTypes.mdmCertificateExpirations];
    },

    showChart() {
      return this.certificateDetails.length;
    },
  },

  created() {
    this.fetchMdmConfig();
  },

  methods: {
    ...mapActions(administratorModel, ['resetMdm']),

    async fetchMdmConfig() {
      const mdmData = await MdmsApi.fetchMdm();
      if (mdmData[0]?.apnsCertExpiry !== undefined) {
        this.resetMdm(true);
        const apnsCertExpiry = new Date(mdmData[0]?.apnsCertExpiry);
        const noOfDaysApnsCertExpiry = DateUtil.daysUntil(apnsCertExpiry);

        if (noOfDaysApnsCertExpiry <= 365) {
          const series = [];
          series.push(
            percentage - (noOfDaysApnsCertExpiry * percentage) / 365,
          );
          const daysSeries = noOfDaysApnsCertExpiry;
          const labels = ['APNs Configuration'];
          const detailObj = {
            series,
            labels,
            noData: false,
            daysSeries,
          };
          this.certificateDetails.push(detailObj);
        }
      } else {
        this.resetMdm(false);
      }

      if (mdmData[0]?.depAccessTokenExpiry !== undefined) {
        const depAccessTokenExpiry = new Date(mdmData[0]?.depAccessTokenExpiry);
        const noOfDaysDepAccessTokenExpiry = DateUtil.daysUntil(
          depAccessTokenExpiry,
        );
        if (noOfDaysDepAccessTokenExpiry <= 365) {
          const series = [];
          series.push(
            percentage - (noOfDaysDepAccessTokenExpiry * percentage) / 365,
          );
          const daysSeries = noOfDaysDepAccessTokenExpiry;
          const labels = ['Automated Device Enrollment'];
          const detailObj = {
            series,
            labels,
            noData: false,
            daysSeries,
          };
          this.certificateDetails.push(detailObj);
        }
      } else {
        const daysSeries = 0;
        const series = [0];
        const labels = ['Automated Device Enrollment'];
        const detailObj = {
          series,
          labels,
          noData: true,
          daysSeries,
        };
        this.certificateDetails.push(detailObj);
      }
      this.fetchVppConfig();
    },

    async fetchVppConfig() {
      const vppData = await AppleVppApi.getLocations();
      const labels = [];
      const series = [];
      const detailObj = {};
      labels.push('VPP');
      detailObj.labels = labels;

      if (vppData.locations[0]?.sTokenExpiry !== undefined) {
        const vppTokenExpiry = new Date(vppData.locations[0]?.sTokenExpiry);
        const noOfDaysVppTokenExpiry = DateUtil.daysUntil(vppTokenExpiry);
        if (noOfDaysVppTokenExpiry <= 365) {
          series.push(
            percentage - (noOfDaysVppTokenExpiry * percentage) / 365,
          );
          const daysSeries = noOfDaysVppTokenExpiry;
          detailObj.series = series;
          detailObj.noData = false;
          detailObj.daysSeries = daysSeries;
          this.certificateDetails.push(detailObj);
        }
      } else {
        detailObj.daysSeries = 0;
        detailObj.noData = true;
        detailObj.series = [0];
        this.certificateDetails.push(detailObj);
      }

      this.isLoading = false;
    },

    navigateToMDMPage() {
      this.triggerMDMButtonClickedHandler('MDM', this.$options.viewAllRoute);
      Util.redirect(this.$options.mdmRoutes);
    },
  },
};
</script>
